#local-sandbox-instance-form-field {
  margin-left: calc(var(--spacer) * 3.3);
}

gz-dropdown {
  --form-field-input-width: 400px;
}

gz-info-box {
  padding-left: calc(var(--spacer) * -1);
}
